<template>
  <div class="HistoryMsgList">
    <div v-for="(chat, chatIndex) in messages" :key="chatIndex">
      <div v-if="chat.messageType !== 'HOLD'">
        <div v-if="chat.messageType === 'START'" class="msgLine">
          <div class="box"><span class="chatIcon">상담사가 연결되었습니다.</span></div>
        </div>
        <div v-if="chat.messageType === 'CONNECT'" class="msgLine">
          <div class="box"><span class="chatIcon" v-html="parseTextFromContent(chat.content, chat.senderType)"></span></div>
        </div>
        <!-- UserMsg -->
        <div v-else-if="chat.senderType === 'USER'" class="userMsg">
          <div class="balloonBox">
            <div class="time">{{ printCreateMessageDateTime(chat.createDate) }}</div>
            <div class="msgBg">
              <ImageList v-if="chat.messageType === 'PHOTO'" :content="chat.content"></ImageList>
              <video v-else-if="chat.messageType === 'VIDEO'" controls @click="videoClick(getVideoFromContent(chat.content))" class="VIDEO">
                <source :src="getVideoFromContent(chat.content)" />
              </video>
              <div v-else class="txt">
                <span v-html="parseTextFromContent(chat.content, chat.senderType, chat.messageType)" @click="nativeOpenLink"></span>
              </div>
            </div>
          </div>
          <open-graph :og="JSON.parse(chat.content)"></open-graph>
        </div>
        <!-- // UserMsg -->
        <!-- chatMsg -->
        <div
          v-else-if="
            chat.messageType !== 'BROWSER_EXIT' &&
            chat.messageType !== 'TAKE_OVER' &&
            chat.messageType !== 'AUTO_CLOSE' &&
            chat.messageType !== 'BAN_WORD' &&
            chat.messageType !== 'FAQ' &&
            !(chat.messageType === 'END' && chat.channelName === 'SCENARIO')
          "
          class="systemBox"
        >
          <div class="name" :class="{ systemIcon: chat.messageType === 'SCENARIO' }">
            <div v-if="$isSeller">
              {{ headerStyle.toolbarAgentName || '상담사' }}
            </div>
            <div v-else>
              <img :src="checkImage(chat)" />
              {{ headerStyle.toolbarAgentName || '상담사' }}
            </div>
          </div>
          <div class="balloonBox">
            <div
              class="msgBg"
              :class="{ dimmed: ($parent.isEnd && chat.messageType !== 'SURVEY') || ($parent.isChatBotEnd && chat.messageType === 'SCENARIO') }"
              :style="{ width: hasChatButtons(chat.content) ? '100%' : 'auto' }"
            >
              <div v-if="chat.messageType === 'COMBINATION' || chat.messageType === 'SURVEY'" class="TEXT">
                <p class="txt" :style="{ paddingTop: chat.buttons ? '5px' : '0' }" v-html="parseTextFromContent(chat.content, chat.senderType)"></p>
                <div class="btns" v-if="hasChatButtons(chat.content)">
                  <ButtonContents
                    :messageType="chat.messageType"
                    :chatIndex="chatIndex"
                    :scenarioData="scenarioCheckData"
                    :clickedCategory="clickedCategory"
                    :chatButtons="JSON.parse(chat.content).buttons"
                  />
                </div>
              </div>
              <ImageList v-else-if="chat.messageType === 'PHOTO'" :content="chat.content" @imgLoaded="imgLoaded"></ImageList>
              <!--  챗봇  -->
              <div v-else-if="chat.messageType === 'SCENARIO'">
                <ScenarioList :chatIndex="chatIndex" :chat="chat" :clickedCategory="clickedCategory" :scenarioData="scenarioCheckData">
                </ScenarioList>
              </div>
              <div v-else class="TEXT">
                <span class="txt" v-html="parseTextFromContent(chat.content, chat.senderType)" @click="nativeOpenLink"></span>
              </div>
            </div>
            <span class="time">{{ printCreateMessageDateTime(chat.createDate) }}</span>
          </div>
          <open-graph :og="JSON.parse(chat.content)"></open-graph>
        </div>
        <!-- // chatMsg -->
        <!--            <div v-if="chat.messageType === 'BROWSER_EXIT'" class="msgLine">-->
        <!--                <div class="box"><span :class="{ botIcon: chat.channelName ==='SCENARIO', chatIcon: chat.channelName === 'WEB_CHAT' }" v-html="parseTextFromContent(chat.content, chat.senderType)"></span></div>-->
        <!--            </div>-->
        <div v-if="chat.messageType === 'END' && chat.channelName === 'SCENARIO'" class="msgLine">
          <div class="box"><span class="botIcon">챗봇 상담이 종료되었습니다.</span></div>
        </div>
        <div v-if="chat.messageType === 'END' && chat.channelName === 'WEB_CHAT'" class="msgLine">
          <div class="box"><span class="chatIcon">웹챗 상담이 종료되었습니다.</span></div>
        </div>
        <div v-if="chat.messageType === 'AUTO_CLOSE'" class="msgLine autoCloseText">
          <p class="time">{{ printCreateMessageDateTime(chat.createDate) }}</p>
          <div class="box" v-html="parseTextFromContent(chat.content, chat.senderType)"></div>
        </div>
        <div v-if="chat.messageType === 'BAN_WORD'" class="msgLine">
          <div class="box">
            <span class="banWordIcon"><i class="UXicon-warning"></i>{{ parseTextFromContent(chat.content, chat.senderType) }}</span>
          </div>
        </div>
        <!-- 커스텀 검색 기능 -->
        <div
          v-if="!$isSeller && chat.senderType !== 'USER' && chat.messageType === 'FAQ'"
          class="systemBox"
          :class="isSearchButton && 'searchMargin'"
        >
          <div class="name" :class="{ systemIcon: chat.messageType === 'SCENARIO' }" v-if="!isSearchButton(chat)">
            <div>
              <img :src="checkImage(chat)" />
              {{ headerStyle.toolbarAgentName || '상담사' }}
            </div>
          </div>
          <div class="balloonBox">
            <div class="msgBg" :class="{ dimmed: $parent.isChatBotEnd }" style="width: 100%">
              <FaqList :chatIndex="chatIndex" :chat="chat" :scenarioData="scenarioCheckData" :clickedCategory="clickedCategory" />
            </div>
            <span class="time">{{ printCreateMessageDateTime(chat.createDate) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import helpers from '@/util/helpers';
import messageUtil from '@/util/messages';
import ScenarioList from './ScenarioList';
import ButtonContents from './ButtonContents';
import OpenGraph from './OpenGraph';
import FaqList from './FaqList';
import Autolinker from 'autolinker';
import { mapGetters } from 'vuex';
import { searchLayoutHelper } from '@/components/mixin/custom/search';
import ImageList from './ImageList';

export default {
  name: 'HistoryMsgList',
  components: {
    ScenarioList,
    ButtonContents,
    OpenGraph,
    FaqList,
    ImageList
  },
  mixins: [searchLayoutHelper],
  computed: {
    ...mapGetters(['chatRoomData'])
  },
  props: ['messages', 'chatRoomId', 'scenarioCheckData'],
  data() {
    return {
      headerStyle: {}
    };
  },
  mounted() {
    this.headerStyle = this.chatRoomData.headerStyle;
  },
  methods: {
    clickedCategory() {
      return false;
    },
    getVideoFromContent(content) {
      const jsonContent = JSON.parse(content);
      return jsonContent.url;
    },
    videoClick(url) {
      this.$mitt.emit('windowOpen', {
        url: process.env.VUE_APP_WEBCHAT_URL + '/video/chat/open?videoUrl=' + url,
        target: '_blank',
        features: 'location=1,status=1,toolbar=1,scrollbars=1,resizeable=1,width=800,height=800'
      });
    },
    printCreateMessageDateTime(datetimeString) {
      return helpers.printTimeStampMessageFromDateTime(datetimeString);
    },
    nativeOpenLink(e) {
      if (e.target.matches('.nativeBtn')) {
        let http = e.target.innerText.indexOf('http') !== -1 ? '' : 'http://';
        this.$mitt.emit('windowOpen', {
          url: http + e.target.innerText,
          target: '',
          features: ''
        });
      }
    },
    parseTextFromContent(content, type, messageType) {
      const jsonContent = JSON.parse(content);
      if (messageType && messageType === 'END') {
        jsonContent.text = jsonContent.text.split('<br>').join('\n');
      }
      const parseContent = type === 'SYSTEM' ? jsonContent.text : messageUtil.xssCheck(jsonContent.text);
      if (jsonContent.code === undefined) {
        jsonContent.text = Autolinker.link(parseContent, {
          stripPrefix: false,
          replaceFn(match) {
            if (match.getType() === 'url') {
              if (
                /android/i.test(navigator.userAgent) ||
                /iPhone|iPad/i.test(navigator.platform) ||
                window.navigator.userAgent.toUpperCase().indexOf('KAKAO') > -1
              ) {
                return `<a class="nativeBtn" href="${match.url}" target="_blank">${match.matchedText}</a>`;
              } else {
                return true;
              }
            }
            if (match.getType() === 'phone') {
              return `<a href="tel:${match.number}">${match.matchedText}</a>`;
            }
          }
        });
      }
      return jsonContent.text;
    },
    getImageFromContent(content) {
      const jsonContent = JSON.parse(content);
      return jsonContent.url;
    },
    imageClick(content) {
      const jsonContent = JSON.parse(content);
      this.$mitt.emit('windowOpen', {
        url: jsonContent.url,
        target: 'imageWindow',
        features: 'toolbar=no,menubar=no,resizeable=1,width=800,height=800'
      });
    },
    hasChatButtons(content) {
      const jsonContent = JSON.parse(content);
      return !!(jsonContent.buttons && jsonContent.buttons.length > 0);
    },
    checkImage(chat) {
      if (chat.messageType === 'SCENARIO' || chat.messageType === 'FAQ') {
        return (
          (this.headerStyle && this.headerStyle.toolbarAgentIconPath) ||
          'https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/icon_chatbot_v2.png'
        );
      } else {
        return (
          (this.headerStyle && this.headerStyle.toolbarAgentIconPath) ||
          'https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/common/icon_webchat_v2.png'
        );
      }
    }
  }
};
</script>

<style lang="scss">
.HistoryMsgList {
  padding-bottom: 76px !important;
  .msgBg {
    background-color: #f5f5f5 !important;
    .btns a {
      background-color: #f5f5f5 !important;
      cursor: auto;
      &:hover {
        border-color: #d1d1d1 !important;
      }
      &.on {
        background-color: #6d8dff !important;
      }
    }
  }
  .userMsg {
    .msgBg {
      background-color: #737373 !important;
    }
  }
}
</style>
